import { BackendQueryKeys, useTypeSafeQuery } from '@oresundsbron/api';

export function useSinglePressItem(pressId: number) {
  return useTypeSafeQuery(
    BackendQueryKeys.SingleNewsInfo({ id: pressId } ?? {}),
    ({ PressRelease }) => PressRelease.getSinglePressFeed(pressId),
    {
      retry: 0,
    }
  );
}
